export default __webpack_public_path__ + "static/whitepaper_trz_v1.1_en-4ffa57f0a601a3665c3252ca27f8a684.pdf";